module.exports = __webpack_public_path__ + "static/img/logo.2967723a.png";